import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddItemsToModelController.php
* @route '/api/dossier/{dossier}/model/{model}/item'
*/
const AddItemsToModelController = (args: { dossier: string | number | { id: string | number }, model: string | number } | [dossier: string | number | { id: string | number }, model: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemsToModelController.url(args, options),
    method: 'post',
})

AddItemsToModelController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/model/{model}/item',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddItemsToModelController.php
* @route '/api/dossier/{dossier}/model/{model}/item'
*/
AddItemsToModelController.url = (args: { dossier: string | number | { id: string | number }, model: string | number } | [dossier: string | number | { id: string | number }, model: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            model: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        model: args.model,
    }

    return AddItemsToModelController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{model}', parsedArgs.model.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\AddItemsToModelController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/AddItemsToModelController.php
* @route '/api/dossier/{dossier}/model/{model}/item'
*/
AddItemsToModelController.post = (args: { dossier: string | number | { id: string | number }, model: string | number } | [dossier: string | number | { id: string | number }, model: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddItemsToModelController.url(args, options),
    method: 'post',
})

export default AddItemsToModelController